import React from 'react';
import { BrowserRouter, Route, Routes , Navigate} from 'react-router-dom';
import './App.css';
import HomeComponent from './Components/HomeComponent';
import ErrorComponent from './Components/ErrorComponent';
import PostLogonComponent from './Components/PostLogonComponent/PostLogonComponent';
import PreLogonComponent from './Components/PreLogonComponent';
import LogoutComponent from './Components/LogoutComponent';
import { SapphireProvider, defaultTheme } from '@sapphire-react/core';


function App() {
  return (
    <>
      <SapphireProvider theme={defaultTheme} locale="en-FI">
        <BrowserRouter>
          <Routes>
            <Route path="/:language" element={<HomeComponent/>}/>
            <Route path="/" element={<Navigate to={`/fi`} replace />} />

            <Route path="/:language/logon/error" element={<ErrorComponent ErrorType='PostLogonError'/>} />
            <Route path="/logon/error" element={<Navigate to={`/fi/logon/error`} replace />} />

            <Route path="/:language/signin/error" element={<ErrorComponent ErrorType='PreLogonError' /> } />
            <Route path="/signin/error" element={<Navigate to={`/fi/signin/error`} replace />} />

            <Route path =":language/error" element={<ErrorComponent ErrorType='GenericError'/>} />
            <Route path ="/error" element={<Navigate to={`/fi/error`} replace />} />

            <Route path="/:language/logon" element={<PostLogonComponent/>}/>
            <Route path="/logon" element={<PostLogonComponent/>}/>

            <Route path="/:language/signin" element={<PreLogonComponent/>}/>
            <Route path="/signin" element={<PreLogonComponent/>}/>

            <Route path="/:language/logout" element={<LogoutComponent/>}/>
            <Route path="/logout" element={<LogoutComponent/>}/>

            <Route path="/:language/*" element={<ErrorComponent ErrorType='NoPageFound'/>} />
            <Route path="*" element ={<Navigate to={`/fi/*`} replace />} />
          </Routes>
        </BrowserRouter>
      </SapphireProvider>
    </>
  );
}

export default App;
